import React from 'react';
import { Card } from '@/lib/components/ui/card';
import { useSelector } from 'react-redux';
import { getAllRoles } from '@/data/store/selectors';

interface RolesContentProps {
  selectedRoles: Set<string>;
  onRoleToggle: (roleId: string) => void;
  onRoleClick?: (roleId: string) => void;
}



export const RolesContent: React.FC<RolesContentProps> = ({ selectedRoles, onRoleToggle }) => {

  const roles = useSelector(getAllRoles)
  return (
    <div className="bg-gradient-to-br from-gray-50/30 via-white to-blue-50/20 p-8">
      <div className="animate-fade-in mb-8">
        <h2 className="bg-gradient-to-r from-gray-900 to-blue-900 bg-clip-text text-3xl font-bold text-transparent">
          User Roles
        </h2>
        <p className="animate-fade-in animation-delay-100 mt-2 text-gray-600">
          Select which roles should have access to this resource
        </p>
      </div>

      <div className="grid gap-6 md:grid-cols-2 lg:grid-cols-3">
        {roles.map((role, index) => {
          const isSelected = selectedRoles.has(role.id);

          return (
            <Card
              key={role.id}
              className={`group animate-fade-in relative cursor-pointer overflow-hidden border-2 bg-white/60 p-6 backdrop-blur-sm transition-all duration-300 hover:-translate-y-1 hover:shadow-lg hover:shadow-black/5 ${
                isSelected
                  ? 'scale-[1.02] transform border-blue-500/50 bg-gradient-to-br from-blue-50 to-blue-100/50 shadow-lg shadow-blue-100'
                  : 'border-gray-200/50 hover:border-blue-300 hover:bg-blue-50/30'
              }`}
              style={{ animationDelay: `${index * 100 + 200}ms` }}
              onClick={() => onRoleToggle(role.id)}
            >
              {/* Selection Indicator */}
              {isSelected && (
                <div className="absolute top-3 right-3">
                  <div className="flex h-6 w-6 items-center justify-center rounded-full bg-blue-100 shadow-sm">
                    <div className="h-2 w-2 rounded-full bg-blue-600"></div>
                  </div>
                </div>
              )}

              <div className="flex flex-col">
                <h3
                  className={`text-lg font-semibold transition-colors ${
                    isSelected ? 'text-gray-900' : 'text-gray-700 group-hover:text-gray-900'
                  }`}
                >
                  {role.name}
                </h3>
                <p
                  className={`mt-2 text-sm leading-relaxed transition-colors ${
                    isSelected ? 'text-blue-700' : 'text-gray-500 group-hover:text-gray-600'
                  }`}
                >
                  {role.description}
                </p>
              </div>
            </Card>
          );
        })}
      </div>
    </div>
  );
};
